import showdown from "showdown" 

export default function(o, done){

  var update = function(){
    o.render(o)
  }

  document.title = 'Open Memory Box'

  // var slideshowDiv =
  //   o.component.slideshow(
  //     o,
  //     { markers: sequenceData.markers },
  //     function(){
  //       done(div)
  //     }
  //   )

  // var converter = new showdown.Converter({
  //   simpleLineBreaks: true,
  //   openLinksInNewWindow: true,
  // })

  o.data.content(o, function(contentData){

    // var type = 'splash'
    // var lang = o.store('lang')
    // var content = _.find(contentData, {view: type})
    // if(content){
    //   var markdown = content[lang]
    //   var html = converter.makeHtml(markdown)
    // } else {
    //   var html = ""
    // }

    var logoDiv =
      $('<div>')
      .html('open memory box')
      .css({
        fontSize: o.fontSizeDef.l,
        color: o.colors.yellow,
        marginBottom: '0.35rem',
        marginTop: '0.6em',
      })
  
    var menuDiv =
      o.component.menu(o, true, true)
      .css({
        fontSize: o.fontSizeDef.s,
        padding: 0,
        marginTop: '-0.2rem'
      })
  
    var languagesDiv =
      o.component.languages(o,  update)
      .css({
        fontSize: o.fontSizeDef.s,
        marginTop: '-0.5rem'
      })
  
    // var messageDiv =
    //   $('<div>')
    //   .css({
    //     fontSize: o.fontSizeDef.xs,
    //     marginTop: '1rem',
    //     textTransform: 'none',
    //     color: o.colors.red,
    //     textAlign: 'center',
    //     margin: '0 auto',
    //     padding: '0 2rem',
    //     maxWidth: '34rem',
    //   })
    //   .html(html)
  
    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .css({
      padding: '1rem',
      cursor: 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
    })
    .append([
  
      // slideshowDiv
      // .css({
      //   position: 'fixed',
      //   display: 'flex',
      //   top: 0,
      //   bottom: 0,
      //   left: 0,
      //   right: 0,
      //   zIndex: 0,
      //   alignItems: 'center',
      //   justifyContent: 'center',
      // }),
  
      logoDiv
      .css({
        flex: '0 0 auto',
        zIndex: 1,
      }),
  
      menuDiv
      .css({
        flex: '0 0 auto',
        zIndex: 1,
      }),
  
      languagesDiv
      .css({
        flex: '0 0 auto',
        zIndex: 1,
      }),
  
      // messageDiv
      // .css({
      //   flex: '0 0 auto',
      //   zIndex: 1,
      // }),
  
    ])

    // setTimeout(function(){
    //   messageDiv.hide()
    // }, 20000)
  
    done(div)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/splash/splash.js